import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import Tabber from 'components/Tabber';
import SeoTab from 'components/SeoTab';
import WhatToSeeEditMain from 'components/WhatToSeeEditMain';
import WhatToSeeEditExtra from 'components/WhatToSeeEditExtra';
import WhatToSeeSidebar from 'components/WhatToSeeSidebar';
import MediaEditor from 'components/MediaEditor';

import { withData } from 'lib';
import { ContentWhatToSeeEditPageQuery } from '__generated__/ContentWhatToSeeEditPageQuery.graphql';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';

const query = graphql`
  query ContentWhatToSeeEditPageQuery($id: ID!) {
    whatToSee(id: $id) {
      name

      ...WhatToSeeSidebar_whatToSee
      ...WhatToSeeEditMain_whatToSee
      ...MediaEditor_mediable
      ...WhatToSeeEditExtra_whatToSee
      ...SeoTab_seoable
    }

    ...WhatToSeeEditMain_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentWhatToSeeEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/content', name: 'Turinys' },
  { link: '/content/what-to-sees', name: 'Ką pamatyti' },
];

const ContentWhatToSeeEditPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ContentWhatToSeeEditPageQuery>(
    query,
    preloadedQuery
  );

  const { whatToSee } = data;

  if (!whatToSee) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<WhatToSeeSidebar whatToSee={whatToSee} />}
      breadcrumbs={[...breadcrumbs, { name: whatToSee.name }]}>
      <Tabber
        tabs={[
          {
            title: 'Bendra informacija',
            component: <WhatToSeeEditMain whatToSee={whatToSee} data={data} />,
            hash: 'main',
          },
          {
            title: 'Nuotrauka',
            component: <MediaEditor limit={1} mediable={whatToSee} />,
            hash: 'media',
          },
          {
            title: 'Papildoma informacija',
            component: <WhatToSeeEditExtra whatToSee={whatToSee} />,
            hash: 'extra',
          },
          {
            title: 'SEO',
            component: (
              <SeoTab
                type="WHAT_TO_SEE"
                urlPrefix="/ka-pamatyti/"
                seoable={whatToSee}
              />
            ),
            hash: 'seo',
          },
        ]}
      />
    </PageWithSidebar>
  );
};

export default withData<ContentWhatToSeeEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton tabs={4} breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(ContentWhatToSeeEditPage);
